import ContentBox from '../components/ContentBox'
import EmojiSymbolsIcon from '@material-ui/icons/EmojiSymbols';
import BrushIcon from '@material-ui/icons/Brush';
import { AcademicCapIcon, BadgeCheckIcon, BookOpenIcon, BriefcaseIcon, IdentificationIcon, PresentationChartLineIcon, PuzzleIcon } from '@heroicons/react/outline';
import { useState } from 'react';
import { connect } from "react-redux";
import DetailContentBox from '../components/DetailContentBox';
import ContentAboutme from '../components/content/ContentAboutme';
import ContentEducation from '../components/content/ContentEducation';
import ContentPublication from '../components/content/ContentPublication';
import ContentCertificate from '../components/content/ContentCertificate';
import ContentExtraCur from '../components/content/ContentExtraCur';
import ContentWorkExp from '../components/content/ContentWorkExp';
import ContentProject from '../components/content/ContentProject';
import ContentSkill from '../components/content/ContentSkill';
import ContentInterest from '../components/content/ContentInterest';
import { handleTitleResume } from '../../../services/actions/actions';


function Content({ resumeReducer, handleTitle }) {
    const { personalDetail, educationDetail, publicationDetail, certificateDetail, extracurricularDetail, projectDetail, workDetail, skills, intrests } = resumeReducer
    const [whichContentBoxToShow, setWhichContentBoxToShow] = useState('')
    const [component, setComponent] = useState('')
    const handleDisplayContentBox = (view, component) => {
        window.scrollTo(0, 0)
        setWhichContentBoxToShow(view)
        setComponent(component)
    }
    return (
        <>
            <div className='mt-5'>
                {whichContentBoxToShow && <DetailContentBox component={component} view={whichContentBoxToShow} onClose={() => setWhichContentBoxToShow('')} />}
                {!whichContentBoxToShow &&
                    <div className='grid grid-cols-1 gap-3'>
                        <ContentBox onClick={() => handleDisplayContentBox('about me', <ContentAboutme personalDetail={personalDetail} />)}>
                            <div className='flex items-center'>
                                <IdentificationIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>About me</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Make a great first impression by presenting yourself in a few sentences.</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('education', <ContentEducation educationDetail={educationDetail} />)}>
                            <div className='flex items-center'>
                                <AcademicCapIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Education</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Show off your primary education,college degrees & semesters</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('publication', <ContentPublication publicationDetail={publicationDetail} />)}>
                            <div className='flex items-center'>
                                <BookOpenIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Publication</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Academic publications or book releases have a dedicated place here.</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('certificate', <ContentCertificate certificateDetail={certificateDetail} />)}>
                            <div className='flex items-center'>
                                <BadgeCheckIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Certificate</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Show off your certificates issued by university/organization for your achievements</span>
                        </ContentBox>
                        {/* <ContentBox onClick={() => handleDisplayContentBox('extracurricular', <ContentExtraCur extracurricularDetail={extracurricularDetail} />)}>
                            <div className='flex items-center'>
                                <PuzzleIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Extracurricular</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Show off your primary education,college degrees & semesters</span>
                        </ContentBox> */}
                        <ContentBox onClick={() => handleDisplayContentBox('workexperience', <ContentWorkExp workDetail={workDetail} />)}>
                            <div className='flex items-center'>
                                <BriefcaseIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Work Experience</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>A place to highlight your professional experience - including internships.</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('project', <ContentProject projectDetail={projectDetail} />)}>
                            <div className='flex items-center'>
                                <PresentationChartLineIcon className='w-8 text-gray-700 mr-2' />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Project</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Worked on a particular challenging project in the past? Mention it here.</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('skills', <ContentSkill skills={skills} />)}>
                            <div className='flex items-center'>
                                <EmojiSymbolsIcon className='w-8 text-gray-700 mr-2' style={{ 'fontSize': '1.9rem' }} />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Skills</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>List your technical, managerial or soft skills in this section.</span>
                        </ContentBox>
                        <ContentBox onClick={() => handleDisplayContentBox('interests', <ContentInterest intrests={intrests} />)}>
                            <div className='flex items-center'>
                                <BrushIcon className='w-8 text-gray-700 mr-2' style={{ 'fontSize': '1.9rem' }} />
                                <span className=' font-bold text-gray-700 manpro text-lg'>Interests</span>
                            </div>
                            <span className='text-gray-600 font-normal text-sm manpro leading-4 inline-block mt-2'>Do you have interests that align with your career aspiration?</span>
                        </ContentBox>
                    </div>
                }
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleTitle: (value) => {
            dispatch(handleTitleResume(value))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(Content)